import PropTypes from "prop-types";
import { toast } from "sonner";

import ConfirmDeleteDialog from "components/modals/ConfirmDeleteDialog";
import { useEmailUrlMutations } from "hooks/useEmailUrlsTable";

// The Semantic ConfirmationModal mounts inside its own trigger, so it unmounts
// with the shadcn row menu; this controlled dialog lives outside the menu.
const DeleteEmailUrlModal = ({ emailUrlId, open, onOpenChange }) => {
  const { remove } = useEmailUrlMutations();

  const handleArchive = async () => {
    try {
      await remove.mutateAsync(emailUrlId);
      toast.success("Email URL archived");
      onOpenChange(false);
    } catch {
      toast.error("Failed to archive the Email URL");
    }
  };

  return (
    <ConfirmDeleteDialog
      open={open}
      onOpenChange={onOpenChange}
      title="Archive Email URL?"
      description="Are you sure you want to archive this Email URL?"
      confirmText="Archive"
      onConfirm={handleArchive}
    />
  );
};

DeleteEmailUrlModal.propTypes = {
  emailUrlId: PropTypes.number.isRequired,
  open: PropTypes.bool,
  onOpenChange: PropTypes.func.isRequired,
};

export default DeleteEmailUrlModal;
